import { useContext } from "react";

import { useTranslation } from "react-i18next";

import moment from "moment";

import DateTime from "components/DateTime";
import TimeZoneContext from "context/timeZone/timeZoneContext";
import { YYYY_MM_DD_HH_mm_ss } from "shared";

import { DAY_UNIT, MIDNIGHT_TIME, TIME_FORMAT } from "./constants";
import { ScheduleDateProps } from "./types";

const ScheduleDate = ({
    fromDate,
    toDate,
    format,
    shouldBeAdjusted
}: ScheduleDateProps) => {
    const { currentTimeZone } = useContext(TimeZoneContext);

    const { t } = useTranslation();

    const getAdjustedToDate = () => {
        if (shouldBeAdjusted) {
            const toDateMoment = moment.utc(toDate);
            const localToDate = toDateMoment.clone().tz(currentTimeZone);

            return localToDate.format(TIME_FORMAT) === MIDNIGHT_TIME
                ? toDateMoment
                      .clone()
                      .subtract(1, DAY_UNIT)
                      .format(YYYY_MM_DD_HH_mm_ss)
                : toDate;
        }

        return toDate;
    };

    return (
        <>
            <DateTime date={fromDate} format={format} /> {t("Dialog##date to")}{" "}
            <DateTime date={getAdjustedToDate()} format={format} />
        </>
    );
};

export default ScheduleDate;
